<template>
  <div id="app">
    <i class="el-icon-error" @click="close" v-if="flag"></i>
    <transition :name="transitionName">

      <router-view/>
    </transition>
  </div>
</template>
<script>
  import {get_visit} from '@/api/module/api';
  export default {
    data(){
      return {
         flag :window && window.process && window.process.versions && window.process.versions['electron'],// 如果为真，则是运行于 electron 里面
        type:'',
        page:1,
        info:{},
        transitionName: ''
      }
    },

    watch:{
      $route(to, from) {
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态;
        if(to.meta.type>from.meta.type){
          this.transitionName = 'slide-left';
        }else{
          this.transitionName = 'slide-right';
        }


      },
      type(val){
        const page={
          1:'/',
          2:'/home',
          3:'/time',
          4:'/detail'
        };

        this.$router.push({
          path:page[val],
          query:{
            page:this.page,
            visit_id:this.info.visit_id
          }
        })
      },
     page(val){
        const pages={
          1:'/',
          2:'/home',
          3:'/time',
          4:'/detail'
        };

        this.$router.push({
          path:pages[this.type],
          query:{
            page:val,
            visit_id:this.info.visit_id
          }
        })
      },
    },
    mounted() {
      // setInterval(()=>{
      //   this.getPage();
      // },2000)

    },

    methods:{
      close(){
        this.$electron.ipcRenderer.send('window-close')
      },
      async getPage(){
        const {data}=await get_visit();
        this.type=data.type;
        this.page=data.page;
        this.info=data;
      }
    }
  }
</script>



<style>
*{padding: 0;margin:0;box-sizing: border-box;font-family: '宋体'!important;}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
::-webkit-scrollbar{display:none;}
  .el-icon-error{
    font-size: 3vw;
    right:1vw;
    top:1vw;
    color:rgba(0,0,0,0.2);
    position: fixed;
    cursor: pointer;
  }
  .back img,.back span{
    cursor: pointer;
  }
</style>
